module.exports = __webpack_public_path__ + "media/usp-barcode-a01948fa.svg";